
import { memo } from "react";
import { starRating } from "../CommonForm/CommonFormInterface";
import Image from "next/image";

const Stars = ({
  field,
  maxStars = 5,
  validRating
}: {
  field: starRating;
  maxStars?: number;
  validRating: number;
}) => {
  return (
    <div
      style={{
        display: "flex",
        gap: "2px",
        ...field?.style,
        alignItems: "center",
      }}
    >
      {[...Array(maxStars)].map((_, index) => {
        return (
          <span
            key={index}
            style={{ display: "flex", gap: "2px", alignItems: "center" }}
          >
            {index < validRating ? (
              <Image
                src={`${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/icons/fill_star.svg`}
                alt={"Start Filled"}
                height={16}
                width={16}
              />
            ) : (
              <Image
                src={`${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/icons/grey_star.svg`}
                alt={"Start Empty"}
                height={16}
                width={16}
              />
            )}
          </span>
        );
      })}
    </div>
  );
};

export default memo(Stars);
